import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import useSEO from "@/hooks/useSEO";
import { COMPANY } from "@/data/content";

const LegalSection = ({ title, children, testId }) => (
  <Reveal>
    <section data-testid={testId} className="border border-line bg-white p-7 sm:p-10">
      <h2 className="font-serif text-xl sm:text-2xl tracking-tight text-charcoal mb-4">{title}</h2>
      <div className="space-y-4 text-sm sm:text-base text-charcoal-mute leading-relaxed">{children}</div>
    </section>
  </Reveal>
);

export { LegalSection };

export const LegalNote = () => (
  <div className="border border-gold/40 bg-ivory px-6 py-5 text-sm text-charcoal-mute leading-relaxed" data-testid="legal-note">
    <span className="font-medium text-charcoal">Please note:</span> this document is a
    general template prepared for SSDE LTD's website. Company registration details
    and any sector-specific legal wording should be confirmed with a qualified
    adviser before the website is launched publicly.
  </div>
);
